import config from "environment";
import { getRequest, postRequest } from "./client";
import { CreateCommentForQuestionPayload, QuestionComment, UpdateCommentContract } from "effno-core";

const { baseApi } = config;

export async function apiGetComment(id: string) : Promise<QuestionComment | null> {
  const fetchURL = `${baseApi}/comments/${id}`;
  return await getRequest(fetchURL, "API/apiGetComment");
}

export async function apiDeleteComment(commentId: string) : Promise<QuestionComment | null> {
  const fetchURL = `${baseApi}/comments/delete/${commentId}`;
  return await getRequest(fetchURL, "API/apiDeleteComment");
}

export async function apiDeleteCommentAndChildren(commentId: string) : Promise<number | null> {
  const fetchURL = `${baseApi}/comments/delete-comment-and-children/${commentId}`;
  return await getRequest(fetchURL, "API/apiDeleteCommentAndChildren");
}

export async function apiUpdateComment(payload: UpdateCommentContract) 
: Promise<QuestionComment | null> {
  const fetchURL = `${baseApi}/comments/update-order`;
  return await postRequest(fetchURL, payload, "API/apiUpdateComment");
}

export async function apiCreateCommentForQuestion(payload: CreateCommentForQuestionPayload) 
: Promise<QuestionComment | null> {
  const fetchURL = `${baseApi}/comments/create`;
  return await postRequest(fetchURL, payload, "API/apiCreateCommentForQuestion");
}

